<template>
    <Teleport to="body">
        <div class="bottom-sheet pointer-events-none fixed top-0 right-0 bottom-0 left-0 z-50">
            <div
                class="no-scrollbar absolute right-0 bottom-0 left-0 flex flex-col overflow-scroll"
                :class="{ visible: open }"
            >
                <div
                    class="pointer-events-auto w-full flex-1 bg-linear-to-t from-[rgba(0,0,0,65)] to-[rgba(0,0,0,0)]"
                    @click="$emit('close')"
                />
                <div
                    class="bg-card border-stroke-1 pointer-events-auto flex w-full flex-col border-t"
                >
                    <div class="flex w-full flex-col gap-6 p-4">
                        <h3
                            class="flex items-center justify-between gap-4 text-base leading-6 font-black tracking-[0.25px] uppercase"
                        >
                            <slot name="title"></slot>
                            <button
                                type="button"
                                class="ml-auto shrink-0"
                                :aria-label="$t('general.close')"
                                @click="$emit('close')"
                            >
                                <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M13.4141 11.9998L18.707 6.70684L17.2928 5.29263L11.9999 10.5856L6.70703 5.29273L5.29281 6.70694L10.5857 11.9998L5.2928 17.2928L6.70703 18.707L11.9999 13.414L17.2928 18.7069L18.707 17.2927L13.4141 11.9998Z"
                                        fill="white"
                                    />
                                </svg>
                            </button>
                        </h3>
                        <slot></slot>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script>
export default {
    name: 'BottomSheet',
    props: {
        open: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['close'],
}
</script>

<style lang="scss">
.bottom-sheet {
    > div {
        max-height: 0;
        height: 100%;
        opacity: 0;
        transition: 350ms 50ms;

        &.visible {
            max-height: 100%;
            opacity: 1;
        }
    }
}
</style>
